import { NgModule } from "@angular/core";
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { CardComponentModule, SharedModule } from "lib-trend-core";
import { CardRadarModule } from '../kanban/card-radar/card-radar.module';
import { ActivityDialogsModule } from './activity-dialogs/activity-dialogs.module';
import { ActivityListComponent } from './activity-list/activity-list.component';
import { TaskCalendarComponent } from './task-calendar/task-calendar.component';
import { TaskDashboardComponent } from './task-dashboard/task-dashboard.component';
import { TaskDetailComponent } from './task-detail/task-detail.component';
import { TaskFormComponent } from './task-form/task-form.component';
import { TaskRangeComponent } from './task-range/task-range.component';
import { TaskRoutingModule } from "./task-routing.module";
import { TaskTodayComponent } from './task-today/task-today.component';
import { TaskComponent } from "./task.component";

/**
 * The activity workspace (SPEC-2026-10-crm-activities-cadence RF-35): the tasks area with its
 * Today, week, month, calendar and dashboard views. The dialogs come from `ActivityDialogsModule`,
 * the deal radar of the context panel from `CardRadarModule` (as the attendance panel does), the
 * KPI tiles and the chart from the dashboard's own modules.
 */
@NgModule({
  imports: [
    TaskRoutingModule,
    SharedModule,
    ActivityDialogsModule,
    CardRadarModule,
    CardComponentModule,
    NgxChartsModule,
  ],
  declarations: [
    TaskComponent,
    TaskFormComponent,
    TaskDetailComponent,
    ActivityListComponent,
    TaskTodayComponent,
    TaskRangeComponent,
    TaskCalendarComponent,
    TaskDashboardComponent,
  ],
  exports: [TaskComponent],
})
export class TaskModule { }
